function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "pins",
    d: "M0.23,43.357l22.907,-0l-0,-31.765c-0,-6.397 -5.132,-11.591 -11.453,-11.591c-6.322,0 -11.454,5.194 -11.454,11.591l0,31.765Zm11.436,-39.936c4.498,-0 8.151,3.696 8.151,8.248c-0,4.553 -3.653,8.249 -8.151,8.249c-4.499,-0 -8.151,-3.696 -8.151,-8.249c-0,-4.552 3.652,-8.248 8.151,-8.248Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPins);
export default __webpack_public_path__ + "static/media/pins.2d7dd50d1355a5c80992e4113166b1b4.svg";
export { ForwardRef as ReactComponent };